<template>
  <div class="d-flex flex-row h-100 w-100">
    <div class="login-background bg-black d-none d-lg-flex">
      <div class="login-video-wrapper">
        <img
          class="w-100"
          aria-hidden="true"
          src="https://static.teamculture.com.br/logos/teamculture-wall.png"
          :alt="labels.teamCultureLogo"
        />
      </div>
    </div>
    <div class="login-content-wrapper flex-grow-1" :class="variant">
      <div class="login-content w-100">
        <b-row class="m-0 p-0 h-100 w-100">
          <router-view>
            <template slot="logo">
              <div class="w-100 text-center">
                <img
                  id="tc-img"
                  aria-hidden="true"
                  src="../assets/logos/logo.svg"
                  :alt="labels.teamCultureLogo"
                  class="logo-block"
                />
              </div>
            </template>
          </router-view>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { showChat } from '@/helpers/chat'

export default {
  computed: {
    variant: function() {
      return this.$route && this.$route.meta
        ? this.$route.meta.variant
        : 'bg-white'
    },
    logoVideo: function() {
      const random = Math.floor(Math.random() * 3 + 1)
      return `login/login-mov${random}.mp4`
    },
    ...mapGetters({
      resources: 'resources',
    }),
    labels: function() {
      return {
        teamCultureLogo: this.resources.general.teamCultureLogo,
      }
    },
  },
  mounted() {
    showChat()
  },
  updated() {
    showChat()
    this.$root.$emit('recordPage')
  },
}
</script>

<style lang="scss">
#tc-img {
  @media (max-width: 425px) {
    max-height: 100px;
  }
}
</style>

<style scoped lang="scss">
.login-video-wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  .logo-video {
    z-index: 0;
    min-height: 100%;
    min-width: 100%;
  }
}

@media (min-width: 1200px) {
  .login-title {
    font-size: 60px;
  }
}

.logo-inline {
  max-width: 300px;
}

.logo-block {
  width: auto;
  max-height: 150px;
  padding-bottom: 20px;
}

.login-background {
  width: calc(100% - 500px);
}

.login-content-wrapper {
  display: flex;
  flex-direction: row;
  z-index: 1;

  .login-content {
    position: relative;
    z-index: 1;
    min-width: 0px;
    flex: 1 1 auto;
    overflow: auto;
    flex-grow: 1;

    @media (max-width: 575.98px) {
      // sm
      padding: 40px;
    }
    @media (max-width: 378px) {
      // sm
      padding: 25px;
    }
    @media (max-width: 330px) {
      // sm
      padding: 10px;
    }
    @media (min-width: 576px) and (max-width: 991.98px) {
      padding: 60px;
      .row {
        padding: 30px !important;
      }
    }
    @media (min-width: 992px) {
      padding: 50px;
      width: 500px !important;
    }
  }
}
</style>
